import React, { useCallback, useEffect, useRef, useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SubNav from "../../../Shared/SubNav";
import socket from "../../../context/socket";
import axios from "axios";
import Carousel from "react-multi-carousel";
import {
  Alert,
  Card,
  Dropdown,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import Chart from "react-apexcharts";
import _ from "lodash";
import { Table, Container, Row, Col, Modal, Button } from "react-bootstrap";
import { ScenarioAnalysis } from "./ScenarioAnalysis";
import { InvestmentTable } from "./InvestmentTable";
import DraftGoalTable from "./DraftGoalTable";
import "../GoalTracker/GoalTracker.css"
import Swal from "sweetalert2";

import AddNewInvestments from "./modals/AddNewInvestments";
import ExternalInvestment from "./ExternalInvestment";
import NewGoalTracker from "./NewGoalTrackerChart";

import { useDispatch, useSelector } from "react-redux";
import { fetchClientData } from "../../../redux/client/clientSlice";
import toast from "react-hot-toast";
import api from "../../../utils/api";
import { formatRupees } from "../../../utils/inputsValidation";

import RetirementData from "../plan-your-goals/cards/RetirementData";
import RetirementResults from "./RetirementResults";
import PortfolioReview from "./portfolio-health-check/PortfolioReview";
import { createPortfolioHealthCheckApi } from "./portfolio-health-check/portfolioHealthCheckApi";
import MFCentralModal from "./modals/MFCentralModal";
import QRUploadModal from "./modals/QRUploadModal";

const phcApi = createPortfolioHealthCheckApi({
  axiosInstance: api,
  prefix: "advisor/overlap-checker",
});
export const GoalTracker = ({ isConnected }) => {
  const navigate = useNavigate();
  const roomId = new URLSearchParams(useLocation().search).get("clientId");
  const [isChecked, setIsChecked] = useState(false);

  const [defSIP, setDefSIP] = useState(0);
  const [isFetchingPortfolio, setIsFetchingPortfolio] = useState(false);
  const [portfolioFetched, setPortfolioFetched] = useState(false);
  const [portfolioPan, setPortfolioPan] = useState(null);
  const [dreamsIntoAction, setDreamsIntoAction] = useState([]);
  const [activeTab, setActiveTab] = useState("scenarioAnalysis");
  const [selectedCard, setSelectedCard] = useState([]);
  const [showHealthCheckModal, setShowHealthCheckModal] = useState(false);
  const [showQRUpoaderModal, setShowQRUpoaderModal] = useState(false);
  console.log("ExternalInvestment", selectedCard);

  const educationGoals = dreamsIntoAction?.filter(
    (dream) => dream._id === "66d028759a75443e96fd3412",
  );

  const filteredItemmarriage = dreamsIntoAction?.filter(
    (dream) => dream._id === "66d0280c9a75443e96fd3411",
  );
  const [isChildrens, setIsChildrens] = useState([]);
  const [isStopSIP, setStopSIP] = useState(false);
  const [mappedItems, setMappedItems] = useState([]);

  const [isSIPSuccess, setSIPSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [socketConnected, setSocketConnected] = useState(isConnected);
  console.log("socketConnected", socketConnected, isConnected);
  const [isRequiredSIP, setRequiredSIP] = useState();
  const [isCurrentProjectedAmount, setCurrentProjectedAmount] = useState();

  const [isGoalLoaded, setIsGoalLoaded] = useState(false);
  const [allExternalFolios, setAllExternalFolios] = useState();
  const [showMFCentralModal, setShowMFCentralModal] = useState(false);
  const [clientGoalMain, setClientGoalMain] = useState([]);
  const [dreamPoints, setDreamPoints] = useState({})
  const [portfolioSummary, setPortfolioSummary] = useState(null);
  const [portfolioSummaryError, setPortfolioSummaryError] = useState("");

  const dispatch = useDispatch();

  /*********chart section:- By Girish ******/
  const [goal, setGoal] = useState({});
  const [mappedFunds, setMappedFunds] = useState([]);
  const [chartData, setChartData] = useState();

  // New RetCal
  const [showRetirementResult, setShowRetirementResult] = useState(false);
  const [retirementResult, setRetirementResult] = useState(null);
  useEffect(() => {
    const savedResult =
      sessionStorage.getItem(`retirementResult_${roomId}`) ||
      sessionStorage.getItem("retirementResult");

    if (savedResult) {
      try {
        const result = JSON.parse(savedResult);

        setRetirementResult(result);
        setShowRetirementResult(true);
      } catch (error) {
        console.error("Failed to load retirement result:", error);
      }
    }
  }, [roomId]);
  const handleRetirementComplete = (result) => {
    console.log("PARENT RECEIVED RESULT:", result);
    setRetirementResult(result);
    setShowRetirementResult(true);
    setActiveTab("scenarioAnalysis");
  };

  // console.log("isRequiredSIP", isRequiredSIP,goal);
  // const [finalGoalTrackerChart, setFinalChart] = useState({});

  useEffect(() => {
    setChartData(generateChartData(goal.accumulatedAmount, goal, "useeffect"));
    console.log(
      "chartData 1",
      goal.accumulatedAmount,
      goal,
      goal?.targetAmount,
    );

    setDefSIP(goal.sipDeficit || goal.monthlysaving);
  }, [goal]);

  useEffect(() => {
    dispatch(fetchClientData(roomId));
  }, []);

  useEffect(() => {
    setIsGoalLoaded(true);
  }, [goal]);
  useEffect(() => {
    setSocketConnected(isConnected);
  }, [isConnected]);

  // useEffect(() => {
  //   // Check if goal data is available and chart data can be generated
  //   if (goal && goal.targetAmount && goal.accumulatedAmount !== undefined) {
  //     console.log("Updated goal data:", goal); // Debug the updated goal
  //     setChartData(generateChartData(goal.accumulatedAmount, goal, defSIP));
  //   }
  // }, [goal, defSIP]); // This will trigger whenever 'goal' or 'defSIP' changes

  const mapFund = (fund) => {
    // setIsLoading(true);
    console.log("mapcall");
    // setIsLoading(true);
    const isDuplicate = mappedFunds.some(
      (existingFund) => existingFund.folioNumber === fund.folioNumber,
    );
    if (isDuplicate) return;

    const updatedFunds = [...mappedFunds, fund];

    const updatedAccumulated = updatedFunds.reduce(
      (total, f) => Number(total) + Number(f.currentValue),
      0,
    );

    const runningSIP = updatedFunds.reduce(
      (total, f) => total + (Number(f.sipAmount) || 0),
      0,
    );

    const sipDeficit = calculateSIPDeficit(updatedAccumulated, goal);
    setDefSIP(sipDeficit);

    // Optional: Add projectedAmount check here (same as in mapFolio) if needed
    setGoal((prevGoal) => ({
      ...prevGoal,
      accumulatedAmount: updatedAccumulated,
      sipDeficit,
      runningSIP,
    }));

    setMappedFunds(updatedFunds);
    setChartData(generateChartData(updatedAccumulated, goal, "mapfund"));
  };

  const mapFundsBulk = (funds) => {
    setMappedFunds((prevFunds) => {
      let updatedFunds = [...prevFunds];

      funds.forEach((fund) => {
        console.log("clicked", fund.folioNumber, fund.fundID);
        if (
          !updatedFunds.some(
            (existingFund) =>
              existingFund.folioNumber === fund.folioNumber &&
              existingFund.fundID === fund.fundID,
          )
        ) {
          updatedFunds.push(fund);
        }
      });

      // console.log("updatedFunds", updatedFunds);
      const updatedAccumulated = updatedFunds.reduce(
        (total, fund) => Number(total) + Number(fund.currentValue),
        0,
      );

      const runningSIP = updatedFunds.reduce(
        (total, fund) => total + (Number(fund.sipAmount) || 0),
        0,
      );

      // const updatedAccumulated = "287354.3";

      // Prepare a goal with updated runningSIP before passing to calc
      const updatedGoal = {
        ...goal,
        runningSIP,
      };

      console.log("updatedAccumulated", updatedAccumulated);
      const sipDeficit = calculateSIPDeficit(updatedAccumulated, updatedGoal);
      setDefSIP(sipDeficit);
      console.log("isgetClgoal");
      setGoal((prevGoal) => ({
        ...prevGoal,
        accumulatedAmount: updatedAccumulated,
        sipDeficit,
        runningSIP,
      }));

      console.log("runningSIP788", runningSIP, updatedAccumulated, sipDeficit);

      const sss = generateChartData(
        updatedAccumulated,
        updatedGoal,
        runningSIP,
        "bulk",
      );
      setChartData(sss);

      return updatedFunds;
    });
  };

  // console.log("g-1",goal);

  const unmapFund = (fund) => {
    // Remove the fund from current mapped list
    const updatedFunds = mappedFunds.filter(
      (f) =>
        !(
          f.currentValue === fund.currentValue &&
          f.folioNumber === fund.folioNumber
        ),
    );

    // Recalculate accumulated amount from updated fund list
    const updatedAccumulated = updatedFunds.reduce(
      (total, f) => Number(total) + Number(f.currentValue),
      0,
    );

    // Recalculate total SIP from updated fund list
    const runningSIP = updatedFunds.reduce(
      (total, f) => total + (Number(f.sipAmount) || 0),
      0,
    );

    // Recalculate SIP deficit
    const sipDeficit = calculateSIPDeficit(updatedAccumulated, goal);
    console.log("isgetClgoal2");

    // Update goal state
    setGoal((prevGoal) => ({
      ...prevGoal,
      accumulatedAmount: updatedAccumulated,
      sipDeficit,
      runningSIP,
    }));

    // Update mapped funds
    setMappedFunds(updatedFunds);

    // Update chart
    setChartData(generateChartData(updatedAccumulated, goal, "unmap"));
  };

  // console.log("mappedFunds-11",mappedFunds);

  /*********chart section:- By Girish ******/

  const [isRedeemSuccess, setRedeemSuccess] = useState(false);

  //  console.log("selectedCard",selectedCard,isRequiredSIP,isCurrentProjectedAmount);
  const [modalShow, setModalShow] = useState(false);

  const [isClientData, setIsClientData] = useState();
  const [isGetClientGoal, setGetClientGoal] = useState();

  const [investmentData, setInvestmentData] = useState({});
  const retirementInvestmentValue = useMemo(() => {
    let total = 0;

    Object.values(investmentData || {}).forEach((category) => {
      Object.values(category || {}).forEach((investments) => {
        if (!Array.isArray(investments)) return;

        investments.forEach((investment) => {
          const goalName = String(investment.goal_name || "")
            .trim()
            .toLowerCase();

          // Include only investments linked to Retirement Planning
          if (goalName === "retirement planning") {
            total += Number(investment.aum_as_per_rta) || 0;
          }
        });
      });
    });

    console.log("RETIREMENT-ONLY INVESTMENT VALUE:", total);

    return total;
  }, [investmentData]);
  useEffect(() => {
    getallFolio();
  }, []);
  const goalId = selectedCard?._id;
  const goalName = selectedCard?.text;

  const getallFolio = async () => {
    try {
      const response = await api.get(`advisor/allFolio/${roomId}`);

      const updatedData = Object.fromEntries(
        Object.entries(investmentData ?? {}).map(([catKey, category]) => [
          catKey,
          Object.fromEntries(
            Object.entries(category ?? {}).map(([subKey, investments]) => [
              subKey,
              (Array.isArray(investments) ? investments : []).map(
                (investment) => ({
                  ...investment,
                  // sub_id: "68ac464411bb954666271c8b", // 👈 inject here
                }),
              ),
            ]),
          ),
        ]),
      );

      console.log("Updated Data:", response.data);

      if (response.data) {
        setInvestmentData(response.data);
        console.log("allFolio data show", response.data);
        //   setInvestmentData({
        //     ...response.data,
        // ...(response.data.sub_id ? {} : { sub_id: "6847ccc2f96da6663e7ab7dc" }),
        //   });
      }
    } catch (error) {
      console.log(error, "some Error");
    }
  };

  useEffect(() => {
    console.log("investmentDataa", investmentData, goalName, isGoalLoaded);

    if (!isGoalLoaded && investmentData) {
      let callCount = 0;
      let fundsToMap = [];

      // console.log("investmentDataa",investmentData,goalName, isGoalLoaded);
      Object.values(investmentData).forEach((category) => {
        Object.values(category).forEach((investments) => {
          investments.forEach((investment) => {
            if (
              shouldIncludeInvestment(
                investment,
                selectedCard,
                goalId,
                goalName,
              )
            ) {
              console.log(
                "Valid Investment",
                investmentData,
                investments,
                investment,
              );
              callCount++;

              fundsToMap.push({
                currentValue: investment.aum_as_per_rta,
                fundID: investment.fundID,
                folioNumber: investment.folio_number,
                sipAmount: investment.sip,
                type: "uf",
              });
            }
          });
        });
      });
      mapFundsBulk(fundsToMap);
      console.log("fundsToMap", fundsToMap, isGoalLoaded, investmentData);
      // setHandleCallCount((prev) => prev + callCount);
    }
  }, [investmentData, goalName, isGoalLoaded]);

  const shouldIncludeInvestment = (
    investment,
    selectedCard,
    goalId,
    goalName,
  ) => {
    if (!investment.goal_name) return false;
    if (
      goalId === "66d0280c9a75443e96fd3411" ||
      goalId === "66d028759a75443e96fd3412"
    ) {
      console.log("goalId", goalId, investment, investment.goal_name);
      return investment.sub_id === selectedCard?.action_data?.[0]?._id;
    }

    return investment.goal_name === goalName;
  };

  const isGoalFound = Object.values(investmentData).some((person) =>
    Object.values(person).some((category) =>
      category.some(
        (investment) => investment.goal_name === selectedCard?.text,
      ),
    ),
  );
  // console.log(
  //   "isGetClientGoal",
  //   isGetClientGoal,
  //   selectedCard.text,
  //   investmentData,
  //   isGoalFound
  // );

  useEffect(() => {
    if (isGetClientGoal === undefined) {
      Swal.fire({
        // title: "Loading client goal Data",
        text: "Please wait...",
        imageUrl: "https://www.finedge.in/assets/images/download.gif",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    } else {
      Swal.close();
    }
  }, [isGetClientGoal]);
  useEffect(() => {
    if (isLoading) {
      Swal.fire({
        // title: "Loading client goal Data",
        text: "Please wait...",
        imageUrl: "https://www.finedge.in/assets/images/download.gif",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        // didOpen: () => {
        //   Swal.showLoading();
        // },
      });
    } else {
      Swal.close(); // Close the alert when loading is done
    }
  }, [isLoading, selectedCard]);

  const [TotalMonthlyOutgo, setTotalMonthlyOutgo] = useState(0);
  const [isMonthly, setMonthly] = useState("");
  const [isTarget, setTargetreturn] = useState("");
  const [abcdDAta, setAbcdData] = useState({
    staticStartYear: 0,
    staticSIP: 0,
    runningSIP: 0,
    staticCAGR: 0,
    staticTargetYear: 0,
    initialTotalMonths: 0,
    stepUp: 0,
    oneTimeInv: 0,
    cagr: 0,
    currentBalance: 0,
    currentRunningSIP: 0,
    targetYear: 0,
    startYear: 0,
    sip: 0,
  });

  const [mapInterNal, setMapInternal] = useState({
    currentValue: 0,
    folioNumber: "",
  });
  const [isDelay, setDelay] = useState("");
  const [isInvestment, setInvestMent] = useState("");
  const [isAccoumulated, setisAccoumulated] = useState("");
  const [isAnnualStepUp, setIsAnnualStepUp] = useState("");
  const [isFiltered, setFiltered] = useState();
  const [isCOBStopped, setCOBStopped] = useState(false);

  const [isFolios, setIsFolios] = useState([]);
  //  console.log("isFiltered", isFiltered);
  const [isFinalResult, setIsFinalResult] = useState();

  const setMapInternalHandle = (dd) => {
    // console.log("jmb89", dd);
    setMapInternal({
      currentValue: dd.savedAmount,
      folioNumber: dd.folioNum,
    });
  };

  const {
    clientData,
    loading: clientLoading,
    error: clientError,
  } = useSelector((state) => state.client);
  // console.log("clientData", clientData);
  const totalRetirementInvestmentValue = retirementInvestmentValue;
  console.log("SSDDFF", retirementInvestmentValue, totalRetirementInvestmentValue)

  useEffect(() => {
    if (clientData?.dreamPoints && Array.isArray(clientData.dreamPoints)) {
      setIsClientData(clientData);
      setIsChildrens(clientData?.children);
      setDreamsIntoAction(clientData?.dreamPoints);

      const selecteddata = clientData.dreamPoints.filter(
        (item) => item.priority > 0 && item.status === 1,
      );

      // Find the smallest priority among the filtered items
      const smallestPriority = selecteddata.length
        ? Math.min(...selecteddata.map((item) => item.priority))
        : null;

      // console.log("Smallest Priority:", smallestPriority);
      // console.log("Filtered Items:", selecteddata);

      // Find and set the item with the smallest priority
      const smallestPriorityItem = selecteddata.find(
        (item) => item.priority === smallestPriority,
      );

      // if (smallestPriorityItem._id==='66d028759a75443e96fd3412') {
      //   console.log("Filtered Items:", selecteddata);
      //   setSelectedCard(smallestPriorityItem);
      // }

      if (smallestPriorityItem) {
        setSelectedCard(smallestPriorityItem);
      }
    } else {
      // Handle the case where dreamPoints is not available or not an array
      setIsChildrens([]);
      setDreamsIntoAction([]);
      setSelectedCard(null); // or any default value you want
    }
  }, [clientData]);

  // for select child card 2nd time
  // useEffect(() => {
  //   if (selectedCard._id === "66d028759a75443e96fd3412") {
  //     const selecteddata = clientData.dreamPoints.filter(
  //       (item) => item.priority > 0 && item.status === 1
  //     );

  //     const smallestPriority = selecteddata.length
  //       ? Math.min(...selecteddata.map((item) => item.priority))
  //       : null;

  //     const smallestPriorityItem = selecteddata.find(
  //       (item) => item.priority === smallestPriority
  //     );

  //     console.log("Filtered Items:", selecteddata);
  //     setSelectedCard(smallestPriorityItem);
  //   }
  // }, [selectedCard]);

  const fetchData = async () => {
    let data = api
      .get(`advisor/personal_finance_ratio_6/${roomId}`)
      .then((response) => {
        const data = response.data;
        console.log("personal_finance_ratio_6", data);
        setTotalInvestibleSurplus(data.final_result.monthly_surplus);
        setIsFinalResult(data.final_result);
        setDreamPoints(data)
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  useEffect(() => {
    if (roomId) {
      fetchData();
    }
  }, [roomId]);

  const [initiatedFolios, setInitiatedFolios] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch draft goal data
  const getDraftGoalData = async () => {
    setLoading(true);
    try {
      const response = await api.post(`advisor/draftInitiatedFolio`, {
        client_id: roomId,
      });
      if (response?.data?.message === "No Events found") {
        return setInitiatedFolios([]);
      }
      setInitiatedFolios(response?.data);
      console.log("initiatedFolios", response.data);
      setIsFolios(response?.data);
      setSIPSuccess(false);
      setRedeemSuccess(false);
      setStopSIP(false);
    } catch (error) {
      console.error("Error fetching draft goal data:", error);
      toast.error("An error occurred while fetching data.");
    } finally {
      setLoading(false);
    }
  };

  const handleCardClick = (card) => {
    console.log("selectedCard12", card);

    if (card?.action_data?.length > 0) {
      console.log("selectedCard123", card);
      getClientGoal(card);
    }
    setSelectedCard(card);
    setMappedFunds([]);

    // ------------------------------
    // 1️⃣ Build advisor goals array (exact same as carousel)
    // ------------------------------
    const advisorGoals = Array.from(
      new Map(
        dreamsIntoAction
          ?.filter(
            (item) =>
              item.priority > 0 &&
              item.action_data?.some((action) => action.status === 1),
          )
          ?.sort((a, b) => a.priority - b.priority)
          ?.map((item) => [item._id, item]),
      ).values(),
    );

    // ------------------------------
    // 2️⃣ Get advisor index
    // ------------------------------
    const advisorIndex = advisorGoals.findIndex((g) => g._id === card._id);

    console.log("Advisor sending:", advisorIndex, card._id);

    // ------------------------------
    // 3️⃣ EMIT SYNC DATA TO CLIENT
    // ------------------------------
    socket.emit("gateway", {
      room: roomId,
      cardId: card._id,
      advisorIndex: advisorIndex,
    });
  };

  // Joining socket room
  useEffect(() => {
    socket.emit("join", roomId);
  }, [roomId]);

  const debouncedEmitMessage = useCallback(
    _.debounce(() => {
      socket.emit("message", {
        room: roomId,
        data: {
          selectedCard,
          isFolios,
          activeTab,
          isCOBStopped,
          isDelay,
          isInvestment,
          isAccoumulated,
          isAnnualStepUp,
          mapInterNal,
          mappedFunds,
          goal,
          isChecked,
        },
      });
      // console.log(
      //   "Emitted response :",
      //   isCOBStopped,
      //   isDelay,
      //   isInvestment,
      //   isAccoumulated,
      //   isAnnualStepUp,
      //   mapInterNal,
      //   mappedFunds,
      //   goal,
      //   isChecked
      // );
    }, 300),
    [
      selectedCard,
      isFolios,
      roomId,
      activeTab,
      isCOBStopped,
      isDelay,
      isInvestment,
      isAccoumulated,
      isAnnualStepUp,
      mapInterNal,
      mappedFunds,
      goal,
      isChecked,
    ],
  );

  useEffect(() => {
    if (activeTab) {
      debouncedEmitMessage();
    }
  }, [
    selectedCard,
    isFolios,
    debouncedEmitMessage,
    activeTab,
    isCOBStopped,
    isDelay,
    isInvestment,
    isAccoumulated,
    isAnnualStepUp,
    mapInterNal,
    mappedFunds,
  ]);

  const getCardStyle3 = (cardId) => {
    // console.log("getCardStyle3", cardId);

    const isSelected =
      selectedCard && selectedCard.action_data?.[0]?.childId === cardId;

    // console.log("tt", isSelected, maritalStatus, selectedCard2?.maritalStatus);

    return {
      backgroundColor: isSelected ? "#f1fcf8" : "white",
      border: isSelected ? "1px solid #52b58c" : "2px solid #ddd",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
      boxShadow: isSelected
        ? "0 4px 8px rgba(0, 0, 0, 0.2)"
        : "0 4px 8px rgba(0, 0, 0, 0.1)",
      width: "95%",
      height: "100px",
    };
  };
  const getCardStyle2 = (cardId, maritalStatus) => {
    // console.log("getCardStyle2", cardId, maritalStatus);

    const isSelected =
      selectedCard &&
      selectedCard.action_data?.[0]?.childId === cardId &&
      selectedCard.action_data?.[0]?.maritalStatus === maritalStatus;

    // console.log("tt", isSelected, maritalStatus, selectedCard2?.maritalStatus);

    return {
      backgroundColor: isSelected ? "#f1fcf8" : "white",
      border: isSelected ? "1px solid #52b58c" : "2px solid #ddd",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
      boxShadow: isSelected
        ? "0 4px 8px rgba(0, 0, 0, 0.2)"
        : "0 4px 8px rgba(0, 0, 0, 0.1)",
      width: "95%",
      height: "100px",
    };
  };
  const getCardStyle = (cardId) => ({
    backgroundColor:
      selectedCard && selectedCard._id === cardId ? "#f1fcf8" : "white",
    border:
      selectedCard && selectedCard._id === cardId
        ? "1px solid #52b58c"
        : "2px solid #ddd",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    boxShadow:
      selectedCard && selectedCard._id === cardId
        ? "0 4px 8px rgba(0, 0, 0, 0.2)"
        : "0 4px 8px rgba(0, 0, 0, 0.1)",
    cursor: "pointer",
    width: "95%",
    height: "100px",
  });

  const prevCardIdRef = useRef(null);

  useEffect(() => {
    // Extract a unique identifier (like _id or goal_id)
    const currentId = selectedCard?._id || selectedCard?.goal_id;

    // Only run if the ID has actually changed and is valid
    if (currentId && currentId !== prevCardIdRef.current) {
      prevCardIdRef.current = currentId;

      setIsGoalLoaded(true);
      setGoal({
        targetAmount: 0,
        accumulatedAmount: 0,
        projectedAchievement: 0,
        projectedShortfall: 0,
        sipDeficit: 0,
        runningSIP: 0,
      });
      console.log("selectedCard1", selectedCard);

      if (selectedCard?.action_data?.length > 0) {
        console.log("selectedCard", selectedCard);
        getClientGoal(selectedCard);
      }
    }
  }, [selectedCard]);

  const getClientGoalData = async () => {
    try {
      const { data } = await api.get(`advisor/get_client_goal/${roomId}`);
      const safeData = Array.isArray(data) ? data : [];
      setClientGoalMain(safeData);
      return safeData; // ✅ important: return data
    } catch (error) {
      console.error("Error fetching goal data", error);
      setClientGoalMain([]);
      return []; // ✅ never return undefined
    }
  };

  const getClientGoal = async (selectedCard) => {
    try {
      setIsLoading(true);
      // const response = await axios.get(
      //   process.env.REACT_APP_API_BASE + `client/get_client_goal/${roomId}`
      // );

      let clientGoalRes = Array.isArray(clientGoalMain) ? clientGoalMain : [];
      if (clientGoalRes.length === 0) {
        clientGoalRes = await getClientGoalData();
      }

      console.log("clientGoalRes", selectedCard, clientGoalRes);

      if (clientGoalRes?.length) {
        setIsGoalLoaded(true);
        const totalOutgo = clientGoalRes.reduce((acc, goal) => {
          return acc + (goal.goalPlanData?.monthlysaving || 0);
        }, 0);
        setTotalMonthlyOutgo(totalOutgo);
      }
      if (selectedCard._id === "66d028759a75443e96fd3412") {
        let selectedChildId = selectedCard.action_data[0].childId;
        let selectedChildEdu = selectedCard.action_data[0].maritalStatus;

        // Search in clientGoalRes for the matching goal
        const matchingGoal = clientGoalRes.find((goal) => {
          return (
            goal._id === selectedCard._id &&
            goal.action_data.some(
              (action) =>
                action.childId === selectedChildId &&
                action.maritalStatus === selectedChildEdu,
            )
          );
        });

        if (matchingGoal) {
          const goalPlanData = matchingGoal.goalPlanData;
          // console.log("Matched goalPlanData:", goalPlanData);

          setFiltered(goalPlanData);

          // console.log("filteredArr.goalPlanData", goalPlanData);
          // const dataa= (filteredArr&&goalPlanData)
          //  console.log("das.", filteredArr && filteredArr);
          setGetClientGoal(goalPlanData);

          /*******Chart Data:- By Girish */
          const isgetClgoal = goalPlanData;
          console.log("isgetClgoal3", isgetClgoal);

          setGoal({
            targetAmount: isgetClgoal.TargetAmount,
            projectedAchievement: 0,
            monthlysaving: isgetClgoal.monthlysaving,
            timeline: isgetClgoal.yearsRemain, // in years
            startYear: isgetClgoal.startyear,
            targetReturn: isgetClgoal.expectedReturn, // CAGR %
            targetYear: isgetClgoal?.goalYear,
            yearLeftText: isgetClgoal.yearLeftText,
            accumulatedAmount: 0,
            projectedAchievement: 0,
            projectedShortfall: 0,
            yearsRemain: isgetClgoal?.yearsRemain || 0,

            sipDeficit: 0,
            runningSIP: 0,
          });

          /*******Chart Data:- By Girish */
          setMonthly(goalPlanData.monthlysaving);
          setTargetreturn(goalPlanData.expectedReturn);
          // setDelay(goalPlanData.yearsRemain);
          setInvestMent(goalPlanData.planOTILabel);
        } else {
          console.log("No matching goal found.");
        }
      } else if (selectedCard._id === "66d0280c9a75443e96fd3411") {
        let selectedChildId = selectedCard.action_data[0].childId;
        // Search in clientGoalRes for the matching goal
        const matchingGoal = clientGoalRes.find((goal) => {
          return (
            goal._id === selectedCard._id &&
            goal.action_data.some(
              (action) => action.childId === selectedChildId,
            )
          );
        });

        if (matchingGoal) {
          const goalPlanData = matchingGoal.goalPlanData;
          // console.log("Matched goalPlanData:", goalPlanData);

          setFiltered(goalPlanData);

          // console.log("filteredArr.goalPlanData", goalPlanData);
          // const dataa= (filteredArr&&goalPlanData)
          //  console.log("das.", filteredArr && filteredArr);
          setGetClientGoal(goalPlanData);

          /*******Chart Data:- By Girish */
          const isgetClgoal = goalPlanData;
          console.log("isgetClgoal4", isgetClgoal);

          setGoal({
            targetAmount: isgetClgoal.TargetAmount,
            yearsRemain: isgetClgoal?.yearsRemain || 0,
            monthlysaving: isgetClgoal.monthlysaving,
            timeline: isgetClgoal.yearsRemain, // in years
            startYear: isgetClgoal.startyear,
            targetReturn: isgetClgoal.expectedReturn, // CAGR %
            targetYear: isgetClgoal.goalYear,
            yearLeftText: isgetClgoal.yearLeftText,
            accumulatedAmount: 0,
            projectedAchievement: 0,
            projectedShortfall: 0,
            sipDeficit: 0,
            runningSIP: 0,
          });

          /*******Chart Data:- By Girish */
          setMonthly(goalPlanData.monthlysaving);
          setTargetreturn(goalPlanData.expectedReturn);
          // setDelay(goalPlanData.yearsRemain);
          setInvestMent(goalPlanData.planOTILabel);
        } else {
          console.log("No matching goal found.");
        }
      } else {
        const filteredArr = clientGoalRes.find(
          (item) => item._id === selectedCard._id,
        );
        setFiltered(filteredArr.goalPlanData);

        // console.log("filteredArr.goalPlanData", filteredArr.goalPlanData);
        // const dataa= (filteredArr&&filteredArr.goalPlanData)
        //  console.log("das.", filteredArr && filteredArr);
        setGetClientGoal(filteredArr.goalPlanData);

        /*******Chart Data:- By Girish */
        const isgetClgoal = filteredArr.goalPlanData;
        console.log("isgetClgoal5", isgetClgoal);

        setGoal({
          targetAmount: isgetClgoal.TargetAmount,
          monthlysaving: isgetClgoal.monthlysaving,
          timeline: isgetClgoal.yearsRemain, // in years
          startYear: isgetClgoal.startyear,
          targetReturn: isgetClgoal.expectedReturn, // CAGR %
          targetYear: isgetClgoal.goalYear,
          accumulatedAmount: isgetClgoal?.accumulatedAmount || 0,
          projectedAchievement: isgetClgoal?.TargetAmount || 0,
          projectedShortfall: isgetClgoal?.monthlySavingAsPerCurrentYear || 0,
          sipDeficit: isgetClgoal?.monthlySavingAsPerCurrentYear || 0,
          runningSIP: isgetClgoal?.runningSIP || 0,
          yearsRemain: isgetClgoal?.yearsRemain || 0,
        });

        /*******Chart Data:- By Girish */
        setMonthly(filteredArr.goalPlanData.monthlysaving);
        setTargetreturn(filteredArr.goalPlanData.expectedReturn);
        // setDelay(filteredArr.goalPlanData.yearsRemain);
        setInvestMent(filteredArr.goalPlanData.planOTILabel);
      }
    } catch (error) {
      console.log("error", error?.response?.data?.error);

      setIsGoalLoaded(false);
    } finally {
      setIsLoading(false);
      setIsGoalLoaded(false);
    }
  };

  useEffect(() => {
    if (roomId) {
      socket.emit("join", { room: roomId });
      socket.emit("message_to", {
        room: roomId,
        data: {
          location: "show_mfcentral_model",
          showMFCentralModal: showMFCentralModal
        },
      });
    }
  }, [showMFCentralModal, roomId]);

  useEffect(() => {
    if (roomId) {
      socket.emit("join", { room: roomId });
      socket.emit("message_to", {
        room: roomId,
        data: {
          location: "show_health_check_modal",
          showHealthCheckModal: showHealthCheckModal,
          portfolioFetched: portfolioFetched,
          portfolioPan: portfolioPan,
        },
      });
    }
  }, [showHealthCheckModal, portfolioFetched, portfolioPan, roomId])


  const handleNext = () => {
    let nextUrl;
    if (clientData?.status !== 1) {
      nextUrl = `/my-investment?clientId=${roomId}`;
    } else {
      nextUrl = `/what-we-will-need-from-you?clientId=${roomId}`;
    }
    socket.emit("navigate", { room: roomId, url: nextUrl });
    navigate(nextUrl);
  };

  const handleBack = () => {
    const prevUrl = `/plan-your-goals?clientId=${roomId}`;
    socket.emit("navigate", { room: roomId, url: prevUrl });
    navigate(prevUrl);
  };
  const handleExternalPortfolioImported = async (pan) => {
    setIsFetchingPortfolio(false);
    setShowMFCentralModal(false);
    const cleanPan = (pan && typeof pan === "string" && pan.trim()) ? pan.trim().toUpperCase() : null;
    if (cleanPan) {
      setPortfolioPan(cleanPan);
    }
    setPortfolioFetched(true);
    setShowHealthCheckModal(true);
    toast.success("External portfolio fetched successfully.");
    if (roomId) {
      socket.emit("join", { room: roomId });
      socket.emit("message_to", {
        room: roomId,
        data: {
          location: "show_mfcentral_model",
          showMFCentralModal: false,
        },
      });
      socket.emit("message_to", {
        room: roomId,
        data: {
          location: "show_health_check_modal",
          showHealthCheckModal: true,
          portfolioFetched: true,
          portfolioPan: cleanPan,
        },
      });
    }
  };

  const handleExternalInvestmentsClick = () => {
    setIsFetchingPortfolio(false);
    setPortfolioFetched(false);
    setShowMFCentralModal(true);
    if (roomId) {
      socket.emit("join", { room: roomId });
      socket.emit("message_to", {
        room: roomId,
        data: {
          location: "show_mfcentral_model",
          showMFCentralModal: true,
        },
      });
    }
  };

  const getAllExternalFolios = async () => {
    try {
      Swal.fire({
        text: "Fetching external folios...",
        imageUrl: "https://www.finedge.in/assets/images/download.gif",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      const response = await api.post(`advisor/getAllExternalFolios`, {
        clientId: roomId,
      });

      Swal.close();
      setAllExternalFolios(response.data);
      // 🔥 Send updated folios live to Client
      if (roomId && response?.data) {
        socket.emit("join", { room: roomId });
        socket.emit("externalInvData", {
          room: roomId,
          message: response.data,
        });
      }
      if (!response?.data) {
        showMFCentralModal(false);
      }
    } catch (error) {
      Swal.close();
      console.error("Error fetching AllExternal Folios data:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch external folios. Please try again later.",
      });
    }
  };

  const yearsLeft = 35;
  const startYear = new Date().getFullYear();

  const years = Array.from({ length: yearsLeft + 1 }, (_, i) => startYear + i);

  const targetAmount = 72780808;
  const seriesData = years.map((year, index) => ({
    x: year,
    y: +((targetAmount / yearsLeft) * index).toFixed(2),
  }));

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };
  const handleSave = (data) => {
    // console.log("handleSave", data);
  };

  const [warmingNewInvestment, setWarmingNewInvestment] = useState(false);

  const handleNewInvestmentsClick = () => {
    if (
      warmingNewInvestment ||
      ![
        "Processed",
        "Sent",
        "Failed",
        "Rejected",
        "Resent",
        "Awaiting Authentication",
      ].includes(isFolios[0]?.eventStatus)
    ) {
      setModalShow(true);
    } else {
      Swal.fire({
        title: "Goal Event in progress",
        text: "Transactions will be unlocked once it’s completed or discarded",
        icon: "warning", // Adds a warning icon
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "swal-confirm-btn  ",
        },
      });
    }
  };

  const updateClientDates = async (data2) => {
    try {
      const response = await api.put(`advisor/update-client-dates`, data2);
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: "FP date updated successfully.",
        });
      }
    } catch (error) {
      console.error("Error fetching AllExternal Folios data:", error);
    }
  };

  const handleSocketToggle = () => {
    setCOBStopped(true);

    // Notify server to end session
    socket.emit("end_session", { clientId: roomId }); // 🔥 Important!

    const data2 = {
      _id: roomId,
      action: "fp_date",
      // "action": clients?.last_phone_conversation && clients.last_phone_conversation,
      date: new Date(),
    };
    console.log("data2", data2);

    setTimeout(() => {
      if (socketConnected) {
        socket.disconnect();
      }
      setSocketConnected(false);
      updateClientDates(data2);
    }, 1000);
  };

  const [TotalInvestibleSurplus, setTotalInvestibleSurplus] = useState();

  // ---------------------------------------------
  const [dreamsIntoActionData, setDreamsIntoActionData] = useState({});
  const getCardData = async () => {
    try {
      const response = await api.get(
        `advisor/get_master_data/dream_action_points`,
      );
      setDreamsIntoActionData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    getCardData();
  }, [roomId]);
  // ---------------------------------------------
  return (
    <>
      <div className="container minht">
        <div className="row align-items-center">
          <div className="col-12 col-md-6 mb-3 mb-md-0">
            <h2 className="text-start">Plan Your Goals</h2>
          </div>

          <div className="col-12 col-md-6">
            <div className="row text-center text-md-start">
              <div className="col-6 col-lg-3 mb-2">
                <p className="para clrgrey fs-12 mb-1">
                  Total Investible Surplus
                </p>
                <h5 className="">{formatRupees(TotalInvestibleSurplus)}</h5>
              </div>

              <div className="col-6 col-lg-3 mb-2">
                <p className="para clrgrey fs-12 mb-1">Total Monthly Outgo</p>
                <h5 className="">{formatRupees(TotalMonthlyOutgo)}</h5>
              </div>

              <div className="col-6 col-lg-3 mb-2">
                <p className="para clrgrey fs-12 mb-1">
                  {TotalInvestibleSurplus - TotalMonthlyOutgo >= 0
                    ? "Surplus"
                    : "Deficit"}
                </p>
                <h5>
                  {formatRupees(TotalInvestibleSurplus - TotalMonthlyOutgo)}
                </h5>
              </div>

              <div className="col-6 col-lg-3 mb-2 d-flex justify-content-center justify-content-md-start align-items-center">
                {/* {socketConnected ? ( */}
                <button
                  className="back-clrgreen minibtn w-100 w-md-auto"
                  onClick={handleSocketToggle}
                >
                  {/* Stop Co-Browsing */}
                  {socketConnected ? "Stop CoBrowsing" : "CoBrowsing Stopped"}
                </button>
                {/* ) : (
                   <span className="fs-12 clrgreen">Co-Browsing Stopped</span>
                 )} */}
              </div>
            </div>
          </div>
        </div>

        <div className="row my-3">
          <div className="col-12 mt-3">
            <Carousel
              additionalTransfrom={0}
              arrows
              autoPlaySpeed={3000}
              centerMode={false}
              className=""
              draggable
              infinite={false}
              keyBoardControl
              minimumTouchDrag={80}
              pauseOnHover
              responsive={{
                desktop: {
                  breakpoint: { max: 3000, min: 1024 },
                  items: 4,
                  partialVisibilityGutter: 40,
                },
                mobile: {
                  breakpoint: { max: 464, min: 0 },
                  items: 1,
                  partialVisibilityGutter: 30,
                },
                tablet: {
                  breakpoint: { max: 1024, min: 464 },
                  items: 2,
                  partialVisibilityGutter: 30,
                },
              }}
              swipeable
            >
              {dreamsIntoAction &&
                (() => {
                  // Step 1: Filter only valid items
                  const uniqueItems = Array.from(
                    new Map(
                      dreamsIntoAction
                        ?.filter(
                          (item) =>
                            item.priority > 0 &&
                            item.action_data?.some(
                              (action) =>
                                action.status === 1 &&
                                Number(action.amount) > 0,
                            ),
                        )
                        ?.sort((a, b) => a.priority - b.priority)
                        ?.map((item) => [item._id, item]),
                    ).values(),
                  );

                  console.log("uniqueItems", uniqueItems);
                  // Step 4: Render cards
                  return uniqueItems.map((item) => (
                    <Card
                      key={item._id}
                      className="image-container Loan brdr increase-size"
                      onClick={() => handleCardClick(item, "mainclick")}
                      style={getCardStyle(item._id)}
                    >
                      <div className="p-3">
                        <div className="row">
                          <div className="col">
                            <div
                              className="reward-text-wrapper "
                              style={{
                                maxHeight: "80px",
                                overflowY: "auto",
                                lineHeight: "1.3",
                                marginTop: "3px",
                                fontSize: "22px",
                                fontWeight: "500",
                              }}
                            >
                              <OverlayTrigger
                                placement="top"
                                delay={{ show: 200, hide: 400 }}
                                overlay={
                                  <Tooltip id={`tooltip-${item._id}`}>
                                    {item.text}
                                  </Tooltip>
                                }
                              >
                                <p className="clrgreen mb-0">
                                  {(() => {
                                    const words =
                                      item.text?.trim().split(/\s+/) || [];
                                    const maxChar = 23; // 🔧 Adjust this based on available width
                                    let currentLength = 0;
                                    let shouldShowEllipsis = false;
                                    const visibleWords = [];

                                    for (let i = 0; i < words.length; i++) {
                                      currentLength += words[i].length + 1; // +1 for space
                                      if (currentLength <= maxChar) {
                                        visibleWords.push(words[i]);
                                      } else {
                                        shouldShowEllipsis = true;
                                        break;
                                      }
                                    }

                                    return visibleWords.map((word, idx) => (
                                      <React.Fragment key={idx}>
                                        {word}
                                        {idx === 0 && <br />}
                                        {idx === visibleWords.length - 1 &&
                                          shouldShowEllipsis &&
                                          "..."}{" "}
                                      </React.Fragment>
                                    ));
                                  })()}
                                </p>
                              </OverlayTrigger>
                            </div>
                          </div>
                          <div className="col">
                            {/* <img
                              src={`assets/images/${item.imgSrc}`}
                              alt=""
                              className="float-end"
                            /> */}
                            <img
                              src={
                                dreamsIntoActionData?.master_values?.find(
                                  (m) => m._id === item._id,
                                )?.imgSrc
                                  ? `assets/images/goal-images/${dreamsIntoActionData?.master_values.find((m) => m._id === item._id).imgSrc}`
                                  : `assets/images/goal-images/Custom-Goal.svg`
                              }
                              alt=""
                              className="float-end text-color goalIcons"
                              width={88}
                              height={56}
                            />
                          </div>
                        </div>
                      </div>
                    </Card>
                  ));
                })()}
            </Carousel>
          </div>

          {/* When Education Card Selected || Do not remove*/}
          {selectedCard?._id === "66d028759a75443e96fd3412" && (
            <div className="col-12 mt-3">
              <Carousel
                additionalTransfrom={0}
                arrows
                autoPlaySpeed={3000}
                centerMode={false}
                className=""
                draggable
                infinite={false}
                keyBoardControl
                minimumTouchDrag={80}
                pauseOnHover
                responsive={{
                  desktop: {
                    breakpoint: { max: 3000, min: 1024 },
                    items: 4,
                    partialVisibilityGutter: 40,
                  },
                  mobile: {
                    breakpoint: { max: 464, min: 0 },
                    items: 1,
                    partialVisibilityGutter: 30,
                  },
                  tablet: {
                    breakpoint: { max: 1024, min: 464 },
                    items: 2,
                    partialVisibilityGutter: 30,
                  },
                }}
                swipeable
              >
                {educationGoals
                  ?.filter(
                    (goal) =>
                      goal.status === 1 &&
                      goal.action_data?.every((action) => action.status === 1),
                  )
                  ?.map((goal) =>
                    goal.action_data.map((action) => {
                      const childName =
                        isChildrens?.find(
                          (child) => child._id === action.childId,
                        )?.name || "Unknown Child";

                      return (
                        <Card
                          key={`${goal._id}-${action._id}`} // Ensure unique key
                          className="image-container Loan brdr increase-size"
                          onClick={() => handleCardClick(goal, action)} // Pass goal and action details
                          style={getCardStyle2(
                            action?.childId,
                            action?.maritalStatus,
                          )}
                        >
                          <div className="p-3">
                            <div className="row">
                              <div className="col">
                                <h5 className="clrgreen">
                                  {childName}'s
                                  <span className="d-block fs-6">
                                    {action.maritalStatus}
                                  </span>
                                </h5>
                              </div>
                            </div>
                          </div>
                        </Card>
                      );
                    }),
                  )}
              </Carousel>
            </div>
          )}
          {/* End When Education Card Selected || Do not remove*/}

          {/* When Marrige Card Selected || Do not remove*/}
          {selectedCard?._id === "66d0280c9a75443e96fd3411" && (
            <div className="col-12 mt-3">
              <Carousel
                additionalTransfrom={0}
                arrows
                autoPlaySpeed={3000}
                centerMode={false}
                className=""
                draggable
                infinite={false}
                keyBoardControl
                minimumTouchDrag={80}
                pauseOnHover
                responsive={{
                  desktop: {
                    breakpoint: { max: 3000, min: 1024 },
                    items: 4,
                    partialVisibilityGutter: 40,
                  },
                  mobile: {
                    breakpoint: { max: 464, min: 0 },
                    items: 1,
                    partialVisibilityGutter: 30,
                  },
                  tablet: {
                    breakpoint: { max: 1024, min: 464 },
                    items: 2,
                    partialVisibilityGutter: 30,
                  },
                }}
                swipeable
              >
                {filteredItemmarriage?.map((goal) =>
                  goal?.action_data
                    ?.filter((action) => Number(action.amount) > 0) // ✅ condition here
                    ?.map((action) => {
                      const childName =
                        isChildrens?.find((child) => child._id === action.childId)
                          ?.name || "Unknown Child";
                      return (
                        <Card
                          key={`${goal._id}-${action._id}`} // Ensure unique key
                          className="image-container Loan brdr increase-size"
                          onClick={() => handleCardClick(goal, action)} // Pass goal and action details
                          style={getCardStyle3(action.childId)}
                        >
                          <div className="p-3">
                            <div className="row">
                              <div className="col">
                                <h5 className="clrgreen">
                                  {childName}'s
                                  <span className="d-block fs-6">
                                    {"Marriage"}
                                  </span>
                                </h5>
                              </div>
                            </div>
                          </div>
                        </Card>
                      );
                    }),
                )}
              </Carousel>
            </div>
          )}
          {/*End When Marrige Card Selected || Do not remove*/}
        </div>

        <>
          <div className="container">
            <div className="row ">
              <div className="col-12">
                <NewGoalTracker
                  setIsLoading={setIsLoading}
                  goal={goal}
                  mappedFunds={mappedFunds}
                  chartData={chartData}
                  isGetClientGoal={isGetClientGoal}
                  mapInterNal={mapInterNal}
                  defSIP={defSIP}
                  setDefSIP={setDefSIP}
                  isGoalFound={isGoalFound}
                  selectedCard={selectedCard}
                  setMapInternal={setMapInternal}
                  roomId={roomId}
                  dreamPoints={dreamPoints}
                  retirementResult={retirementResult}
                  retirementInvestmentValue={totalRetirementInvestmentValue}
                />
              </div>
            </div>
          </div>

          <Container fluid>
            <Row className="mt-4">
              <Col>
                {/* <div className="tabs">
            <button
              className={`tab ${activeTab === 'existingInvestment' ? 'navclr active' : ''}`}
              onClick={() => handleTabClick('existingInvestment')}
            >
              Existing Investment
            </button>
            <button
              className={`tab  ${activeTab === 'scenarioAnalysis' ? 'navclr active' : ''}`}
              onClick={() => handleTabClick('scenarioAnalysis')}
            >
              Scenario Analysis
            </button>
          </div> */}

                {activeTab === "existingInvestment" && (
                  <div className="investment-section">
                    <InvestmentTable
                      getallFolio={getallFolio}
                      selectedCard={selectedCard}
                      defSIP={defSIP}
                      isChildrens={isChildrens}
                      isFiltered={isFiltered}
                      setStopSIP={setStopSIP}
                      isStopSIP={isStopSIP}
                      setRedeemSuccess={setRedeemSuccess}
                      setMapInternalHandle={setMapInternalHandle}
                      setInvestmentData={setInvestmentData}
                      investmentData={investmentData}
                      isGoalLoaded={isGoalLoaded}
                      mapFundsBulk={mapFundsBulk}
                      mapFund={mapFund}
                      unmapFund={unmapFund}
                      isChecked={isChecked}
                      setIsChecked={setIsChecked}
                      shouldIncludeInvestment={shouldIncludeInvestment}
                      isClientData={isClientData}
                      clientGoalMain={clientGoalMain}
                      getDraftGoalData={getDraftGoalData}
                    />
                  </div>
                )}
                {activeTab === "scenarioAnalysis" && (
                  <div className="scenario-section">
                    <ScenarioAnalysis
                      isGetClientGoal={isGetClientGoal}
                      isChildrens={isChildrens}
                      setisAccoumulated={setisAccoumulated}
                      isAccoumulated={isAccoumulated}
                      isTarget={isTarget}
                      setTargetreturn={setTargetreturn}
                      setDelay={setDelay}
                      isDelay={isDelay}
                      isInvestment={isInvestment}
                      isMonthly={isMonthly}
                      setMonthly={setMonthly}
                      setIsAnnualStepUp={setIsAnnualStepUp}
                      isAnnualStepUp={isAnnualStepUp}
                      abcdDAta={abcdDAta}
                      setAbcdData={setAbcdData}
                      currentGoal={goal}
                      allExternalFolios={allExternalFolios}
                    />
                  </div>
                )}
                {activeTab === "externalInvestment" && (
                  <div className="scenario-section">

                    <ScenarioAnalysis
                      isGetClientGoal={isGetClientGoal}
                      setisAccoumulated={setisAccoumulated}
                      isAccoumulated={isAccoumulated}
                      isTarget={isTarget}
                      setTargetreturn={setTargetreturn}
                      setDelay={setDelay}
                      isDelay={isDelay}
                      isInvestment={isInvestment}
                      isMonthly={isMonthly}
                      setMonthly={setMonthly}
                      setIsAnnualStepUp={setIsAnnualStepUp}
                      isAnnualStepUp={isAnnualStepUp}
                      abcdDAta={abcdDAta}
                      setAbcdData={setAbcdData}
                      currentGoal={goal}
                      activeTab={activeTab}
                    />
                  </div>
                )}
              </Col>
            </Row>
          </Container>

          {/* <div className="table-responsive">
                {allExternalFolios ? (
                    <div dangerouslySetInnerHTML={{ __html: allExternalFolios }} />
                ) : (
                    <p className="text-center">No external folios available.</p>
                )}
            </div> */}

          <div className="row justify-content-center mt-5">
            <div className="col-12 col-md-4 col-lg-3 mb-3 mb-md-0">
              {activeTab === "scenarioAnalysis" ? (
                <button
                  onClick={() => handleTabClick("existingInvestment")}
                  className="lrgbutton text-white w-100"
                >
                  EXISTING INVESTMENTS
                </button>
              ) : (
                <button
                  onClick={() => handleTabClick("scenarioAnalysis")}
                  className="lrgbutton text-white w-100 text-uppercase"
                >
                  Scenario Analysis
                </button>
              )}
            </div>

            {/* {clientData?.kyc_info?.is_kyc_done === 'yes' ? ( */}
            <div className="col-12 col-md-4 col-lg-3 mb-3 mb-md-0">
              <button
                className="lrgbutton text-white w-100"
                onClick={handleNewInvestmentsClick}
              >
                NEW INVESTMENTS
              </button>
            </div>
            {/* ) : (
                <div className="col-12 col-md-4 col-lg-3 mb-3 mb-md-0">
                  <button
                    className="lrgbutton text-white w-100"
                    onClick={() =>
                      Swal.fire({
                        icon: "warning",
                        title: "KYC Required",
                        text: "Please complete your KYC before making new investments.",
                        confirmButtonText: "OK",
                        customClass: {
                          confirmButton: "swal-confirm-btn",
                        },
                      })
                    }
                  >
                    NEW INVESTMENTS
                  </button>
                </div>
              )} */}

            {activeTab !== "externalInvestment" ? (
              <div className="col-12 col-md-4 col-lg-3">
                <button
                  className="lrgbutton text-white w-100"
                  onClick={async () => {
                    setPortfolioPan(null);
                    setPortfolioFetched(false);
                    setShowMFCentralModal(false);
                    await setShowHealthCheckModal(true);
                    handleTabClick("externalInvestment");
                  }}
                >
                  REVIEW EXTERNAL PORTFOLIO
                </button>
              </div>
            ) : (
              <div className="col-12 col-md-4 col-lg-3">
                <button
                  className="lrgbutton text-white w-100"
                  onClick={async () => {
                    setPortfolioPan(null);
                    setPortfolioFetched(false);
                    setShowMFCentralModal(false);
                    await setShowHealthCheckModal(true);
                    handleTabClick("externalInvestment");
                  }}
                >
                  REVIEW EXTERNAL PORTFOLIO
                </button>
              </div>
            )}
          </div>

          {activeTab === "externalInvestment" && (
            <div className="scenario-section mt-5">
              <ExternalInvestment
                roomId={roomId}
                selectedCard={selectedCard}
                isChildrens={isChildrens}
                isAccoumulated={isAccoumulated}
                setisAccoumulated={setisAccoumulated}
                setMappedItems={setMappedItems}
                mappedItems={mappedItems}
                isMonthly={isMonthly}
                setMonthly={setMonthly}
                isDelay={isDelay}
                isAnnualStepUp={isAnnualStepUp}
                isTarget={isTarget}
                isGetClientGoal={isGetClientGoal}
                setRequiredSIP={setRequiredSIP}
                abcdDAta={abcdDAta}
                setAbcdData={setAbcdData}
                mapFund={mapFund}
                unmapFund={unmapFund}
                showMFCentralModal={showMFCentralModal}
                setShowMFCentralModal={setShowMFCentralModal}
                setShowHealthCheckModal={setShowHealthCheckModal}
                onOpenPortfolioReview={() => {
                  setPortfolioPan(null);
                  setPortfolioFetched(false);
                  setShowMFCentralModal(false);
                  setShowHealthCheckModal(true);
                }}
                allExternalFolios={allExternalFolios}
                setAllExternalFolios={setAllExternalFolios}
                getAllExternalFolios={getAllExternalFolios}
                onExternalPortfolioImported={handleExternalPortfolioImported}
              />
            </div>

          )}

          <DraftGoalTable
            isSIPSuccess={isSIPSuccess}
            setSIPSuccess={setSIPSuccess}
            roomId={roomId}
            setIsFolios={setIsFolios}
            setStopSIP={setStopSIP}
            isStopSIP={isStopSIP}
            isFiltered={isFiltered}
            selectedCard={selectedCard}
            setWarmingNewInvestment={setWarmingNewInvestment}
            isRedeemSuccess={isRedeemSuccess}
            setRedeemSuccess={setRedeemSuccess}
            initiatedFolios={initiatedFolios}
            setInitiatedFolios={setInitiatedFolios}
            loading={loading}
            setLoading={setLoading}
            getDraftGoalData={getDraftGoalData}
          />
        </>

        <div className="row mt-md-3 mt-4">
          <div className="col">
            <div className="container">
              <div className="row my-4">
                <div className="col text-end">
                  <a href="javascript:void(0);" onClick={handleBack}>
                    <img
                      className="arrow_next1"
                      src="assets/images/left-arrowpng.png"
                      alt=""
                    />
                  </a>
                  <a
                    href="javascript:void(0);"
                    className="ms-1"
                    onClick={handleNext}
                  >
                    <img
                      className="arrow_next"
                      src="assets/images/right-arrow.svg"
                      alt=""
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddNewInvestments
        show={modalShow}
        onHide={() => setModalShow(false)}
        isChildrens={isChildrens}
        isGetClientGoal={isGetClientGoal}
        onSave={handleSave}
        roomId={roomId}
        isClientData={isClientData}
        selectedCard={selectedCard}
        isFiltered={isFiltered}
        isFolios={isFolios}
        setSIPSuccess={setSIPSuccess}
        defSIP={defSIP}
        setDefSIP={setDefSIP}
        getDraftGoalData={getDraftGoalData}
      />
      <Modal
        show={showHealthCheckModal}
        onHide={() => {
          setShowHealthCheckModal(false);
          setPortfolioFetched(false);
          setShowMFCentralModal(false);
          if (roomId) {
            socket.emit("message_to", {
              room: roomId,
              data: {
                location: "show_mfcentral_model",
                showMFCentralModal: false,
              },
            });
          }
        }}
        dialogClassName="mfr-dialog"
        contentClassName="mfr-content"
        backdrop="static"
        keyboard={false}
        centered={false}
        size="xl"
      >
        <Modal.Body className="mfr-body">
          <div className="mfr-page">

            {/* Top bar */}
            <div className="mfr-topbar">
              <button
                type="button"
                className="mfr-close"
                onClick={() => {
                  setShowHealthCheckModal(false);
                  setPortfolioFetched(false);
                }}
                aria-label="Close modal"
              >
                ×
              </button>
            </div>

            {/* Real Lovable-generated Portfolio Health Check interface */}
            <PortfolioReview
              clientId={roomId}
              pan={portfolioPan}
              api={phcApi}
              roomId={roomId}
              isClient={false}
              ready={portfolioFetched}
              fetching={isFetchingPortfolio}
              onRequestFetch={handleExternalInvestmentsClick}
              onClose={() => {
                setShowHealthCheckModal(false);
                setPortfolioFetched(false);
              }}
              reviewLinks={{
                portfolioReview: "https://www.finedge.in/portfolio-review",
                overlapArticle: "https://www.finedge.in/blog/portfolio-review/mutual-fund-portfolio-overlap",
                sif: "https://www.finedge.in/sif-calculator",
              }}
            />

          </div>
        </Modal.Body>
      </Modal>

      {/* Root-level rendering of MFCentralModal and QRUploadModal so they are always mounted */}
      <MFCentralModal
        showMFCentralModal={showMFCentralModal}
        onHideMFCentralModal={() => setShowMFCentralModal(false)}
        roomId={roomId}
        setShowQRUpoaderModal={setShowQRUpoaderModal}
        getAllExternalFolios={getAllExternalFolios}
        onExternalPortfolioImported={handleExternalPortfolioImported}
      />
      <QRUploadModal
        roomId={roomId}
        show={showQRUpoaderModal}
        setShowQRUpoaderModal={setShowQRUpoaderModal}
        client_id={roomId}
        getAllExternalFoliosAdvisor={getAllExternalFolios}
        onExternalPortfolioImported={handleExternalPortfolioImported}
      />
    </>
  );
};

function generateChartData(accumulated, goal, tp) {
  // console.log('chartData', accumulated, goal, tp);

  // const monthsLeft = goal.timeline * 12;

  if (goal.monthlysaving) {
    let currentTime = new Date();
    let targetYear = goal.targetYear;
    const monthsLeft = (Number(goal.targetYear) - Number(goal.startYear)) * 12;
    const monthlyRate = Number(goal.targetReturn) / 1200; // Convert annual rate to monthly
    const targetAmount = goal.targetAmount;
    const sipForTarget = calculateMonthlySIP(
      goal.targetAmount,
      goal.targetReturn,
      goal.timeline,
    ); // SIP amount for target goal

    // console.log('staticSIP78787', sipForTarget, goal.targetAmount, goal.targetReturn, goal.timeline)
    const actualAccumulated = accumulated || 0; // Start from mapped fund if available
    // console.log("monthlyRate", monthlyRate);
    let targetAccumulated = 0;
    let mappedAccumulated = actualAccumulated;
    let capitalGrowth = 0;
    let capitalGrowth1 = 0;
    let monthEndValue = 0;
    let monthEndValue1 = 0;
    let staticSIP = sipForTarget;

    // console.log("sipForTarget", sipForTarget);

    // let staticSIP = 37619;
    let staticCAGR = goal.targetReturn;
    // let staticCAGR = 14;

    let targetGrowthMonthly = [];
    let mappedGrowthMonthly = [];
    let mappedLineVisible = accumulated > 0; // Track visibility of the mapped fund line
    let roundedMonthEndValue = 0;
    let runningSIP = goal.runningSIP;

    // console.log('accumulated', accumulated)
    let myYear = (Number(targetYear) - Number(goal.startYear)) * 12;
    //  let myYear = Number(goal?.yearsRemain) * 12;
    if (targetYear != currentTime.getFullYear())
      staticSIP =
        (targetAmount * (staticCAGR / 1200)) /
        (Math.pow(1 + staticCAGR / 1200, myYear) - 1);

    /****New runningSIP calculation */
    if (runningSIP != 0 || runningSIP != "" || accumulated != 0) {
      let monthEndVal = 0,
        capitalGrow = 0,
        futureVal = 0;
      let testMonths = (targetYear - currentTime.getFullYear()) * 12;

      for (let i = 1; i < testMonths; i++) {
        capitalGrow = ((monthEndVal + runningSIP) * staticCAGR) / 1200;
        monthEndVal = monthEndVal + capitalGrow + runningSIP;
      }
      monthEndVal = monthEndVal + runningSIP;
      // console.log("st12:monthEndVal", monthEndVal);
      let accumUlatedFutureVal =
        parseInt(accumulated) *
        Math.pow(1 + staticCAGR / 100, targetYear - currentTime.getFullYear());

      // console.log("st12:targetYear", targetYear);
      futureVal = Math.round(monthEndVal) + accumUlatedFutureVal;
      // console.log("st12:futureVal", futureVal);
      // console.log("monthEndVal", monthEndVal, accumUlatedFutureVal);
      let remainingVal = targetAmount - futureVal;
      // console.log("st12:remainingVal", remainingVal);
      let requiredSIP =
        (remainingVal * (staticCAGR / 1200)) /
        (Math.pow(1 + staticCAGR / 1200, testMonths) - 1);

      runningSIP =
        (futureVal * (staticCAGR / 1200)) /
        (Math.pow(1 + staticCAGR / 1200, monthsLeft) - 1);

      // console.log("runningSIP29", runningSIP);
      // console.log("futureVal", futureVal, staticCAGR, monthsLeft);
      // $("#sipDeficit" + id).val(requiredSIP);
    }

    console.log("staticSIP111111144", staticSIP);
    /****New runningSIP calculation */

    targetGrowthMonthly.push(staticSIP); // Month 0: only SIP, no growth
    // monthEndValue += staticSIP; // Accumulate SIP, but don’t grow it
    // Loop over each month for SIP calculation

    if (mappedLineVisible) {
      mappedGrowthMonthly.push(Math.round(monthEndValue1));
    } else {
      mappedGrowthMonthly.push(0);
    }

    for (let i = 1; i < monthsLeft; i++) {
      // Target SIP growth
      targetAccumulated += sipForTarget;
      targetAccumulated *= 1 + monthlyRate;

      // capitalGrowth = (monthEndValue * staticCAGR) / 1200;
      capitalGrowth = ((monthEndValue + staticSIP) * staticCAGR) / 1200;
      monthEndValue = monthEndValue + capitalGrowth + staticSIP;
      // console.log(
      //   `Monthzoo ${i}: monthEnd=${monthEndValue.toFixed(
      //     2
      //   )}, SIP=${staticSIP}, CAGR=${staticCAGR}, growth=${capitalGrowth.toFixed(
      //     2
      //   )}, newMonthEnd=${(monthEndValue + capitalGrowth + staticSIP).toFixed(
      //     2
      //   )}`
      // );

      // targetGrowthMonthly.push(Math.round(monthEndValue));
      targetGrowthMonthly[i] = Math.round(monthEndValue);

      // console.log("deficit", deficit);
      // Mapped SIP will only be applied when accumulated is > 0
      if (mappedLineVisible) {
        /********Newcode */
        if (runningSIP == 0) continue;
        capitalGrowth1 = ((monthEndValue1 + runningSIP) * staticCAGR) / 1200;
        // console.log("capitalGrowth1", capitalGrowth1, i);
        monthEndValue1 = monthEndValue1 + capitalGrowth1 + runningSIP;
        // mappedGrowthMonthly.push(Math.round(monthEndValue1));

        // console.log(
        //   `Monthzoo--1 ${i}: monthEnd=${monthEndValue1.toFixed(
        //     2
        //   )}, CAGR=${staticCAGR}, growth=${capitalGrowth1.toFixed(
        //     2
        //   )},runningSIP=${runningSIP}, newMonthEnd=${monthEndValue1}`
        // );

        mappedGrowthMonthly[i] = Math.round(monthEndValue1);

        /********Newcode */
      } else {
        // If no accumulated funds, stop growing the mapped fund line
        mappedGrowthMonthly.push(0);
      }

      // If mappedAccumulated reaches zero or less, hide the mapped fund line
      // if (mappedAccumulated <= 0) {
      //   mappedLineVisible = false;
      // }
    }
    monthEndValue = monthEndValue + staticSIP;
    monthEndValue1 = monthEndValue1 + runningSIP;

    targetGrowthMonthly[monthsLeft] = Math.round(monthEndValue);
    mappedGrowthMonthly[monthsLeft] = Math.round(monthEndValue1);

    // Generate Yearly Labels
    const yearlyLabels = Array.from(
      { length: Number(goal.timeline) + 1 },
      (_, i) => Number(goal.startYear) + i,
    );

    // Extract Yearly Data for Chart X-Axis Alignment
    let yearlyTargetGrowth = yearlyLabels.map(
      (_, index) => targetGrowthMonthly[index * 12] || 0,
    );
    let yearlyMappedGrowth = yearlyLabels.map(
      (_, index) => mappedGrowthMonthly[index * 12] || 0,
    );

    console.log("lineData11", mappedGrowthMonthly);
    console.log("lineData22", targetGrowthMonthly);

    console.log("mappedGrowthMonthly", mappedGrowthMonthly);
    console.log("targetGrowthMonthly", targetGrowthMonthly);

    return {
      series: [
        {
          name: "Target Growth",
          data: targetGrowthMonthly,
          color: "#52B58C",
        },
        {
          name: "Mapped Fund Growth",
          data: mappedGrowthMonthly,
          color: "#B3B3B3",
        },
      ],
      monthlyTargetGrowth: targetGrowthMonthly,
      monthlyMappedGrowth: mappedGrowthMonthly,
      yearlyLabels,
    };
  }
}
function generateProjectedShortfall(accumulated, goal) {
  const months = goal.timeline * 12;
  const monthlyRate = goal.targetReturn / 1200;

  // Projected future value with compound interest
  const finalValue = accumulated * Math.pow(1 + monthlyRate, months);

  // Calculate metrics
  let projectedAchievement = (finalValue / goal.targetAmount) * 100;
  projectedAchievement = Math.min(Math.max(projectedAchievement, 0), 100);
  projectedAchievement = Number(projectedAchievement.toFixed(2));

  let projectedShortfall = goal.targetAmount - finalValue;
  projectedShortfall = Math.round(projectedShortfall);

  return { projectedShortfall, projectedAchievement };
}

/******************New sipdefesit */

function calculateSIPDeficit(accumulated, goal) {
  if (goal.monthlysaving) {
    const currentTime = new Date();
    const targetYear = Number(goal.targetYear || 0);
    let startYear = 0;

    if (goal?.yearLeftText === "Goal Timeline (Years)") {
      startYear = goal.startYear;
    } else {
      startYear = new Date().getFullYear();
    }
    const monthsLeft = (targetYear - startYear) * 12;

    const targetAmount = Number(goal.targetAmount || 0);
    const staticCAGR = Number(goal.targetReturn || 0);
    const timeline = Number(goal.timeline || monthsLeft / 12);
    let runningSIP = Number(goal.runningSIP || 0);
    const accumulatedVal = Number(accumulated || 0);

    const sipForTarget = calculateMonthlySIP(
      targetAmount,
      staticCAGR,
      timeline,
    );

    const testMonths = (targetYear - currentTime.getFullYear()) * 12;

    if (runningSIP !== 0 || accumulatedVal !== 0) {
      let monthEndVal = 0;

      for (let i = 1; i < testMonths; i++) {
        const capitalGrow = ((monthEndVal + runningSIP) * staticCAGR) / 1200;
        monthEndVal += capitalGrow + runningSIP;
      }

      monthEndVal += runningSIP;

      const accumFutureVal =
        accumulatedVal *
        Math.pow(1 + staticCAGR / 100, targetYear - currentTime.getFullYear());

      const futureVal = Math.round(monthEndVal) + accumFutureVal;
      const remainingVal = targetAmount - futureVal;

      const requiredSIP =
        (remainingVal * (staticCAGR / 1200)) /
        (Math.pow(1 + staticCAGR / 1200, testMonths) - 1);

      // 🧾 Clean logging line
      console.log(
        `🧾 SIP Calc → Target: ₹${targetAmount}, Accum: ₹${accumulatedVal}, Start: ${startYear}, Target: ${targetYear}, MonthsLeft: ${monthsLeft}, CAGR: ${staticCAGR}%, RunningSIP: ₹${runningSIP}, SIP(Target): ₹${sipForTarget.toFixed(
          2,
        )}, FutureVal: ₹${futureVal.toFixed(
          2,
        )}, Remaining: ₹${remainingVal.toFixed(
          2,
        )}, RequiredSIP: ₹${requiredSIP.toFixed(2)}`,
      );

      return requiredSIP;
    } else {
      return 0;
    }
  }
}

/******************New sipdefesit */

function calculateFutureValue(principal, rate, years) {
  return principal * Math.pow(1 + rate / 100, years); // Full value with principal
}

function calculateMonthlySIP(targetAmount, annualReturn, timelineYears) {
  const months = timelineYears * 12; // Convert years to months
  const monthlyRate = annualReturn / 12 / 100; // Convert annual return to monthly

  // Future Value Annuity Formula
  const factor = Math.pow(1 + monthlyRate, months) - 1;

  // Avoid division by zero error
  if (factor <= 0) return targetAmount / months;

  const monthlySIP = (targetAmount * monthlyRate) / factor;

  return monthlySIP;
}
